<!-- routify:options title='Status' -->
<!-- routify:options index=1 -->
<!-- routify:options showInNavigation=true -->
<!-- routify:options guards=['canShowSystemStatus'] -->

<script>
    import { t, Notification } from 'totalinvoice-frontend-core'
    import SystemStatus from '../../components/SystemStatus.svelte'

    let authServerStatus = "online"
    let frontendStatus = "online"
    let backendStatus = "online"
    let adminFrontendStatus = "online"
    let adminBackendStatus = "online"
</script>

<h2 class="title is-2 is-spaced page-title">{$t('System Status')}</h2>

<Notification type="is-success" active={true} closable={false} icon={true}>
    <strong>{$t('Everything is up and running')}</strong>
</Notification>

<div class="columns">
    <div class="column is-narrow is-flex is-flex-direction-column is-align-items-flex-end">
        <SystemStatus title="{$t('Auth Server')}" status={authServerStatus} />
        <SystemStatus title="{$t('Frontend')}" status={frontendStatus} />
        <SystemStatus title="{$t('Backend')}" status={backendStatus} />
        <SystemStatus title="{$t('Admin Frontend')}" status={adminFrontendStatus} />
        <SystemStatus title="{$t('Admin Backend')}" status={adminBackendStatus} />
    </div>
</div>
